import { getApi,postApi } from "../../config/api";

export const CollectorJoggingService = {

    "CX++": async function (){
        return false;
    },

    "CX--": async function (){
        return false;
    },

    "CY++": async function (){
        return false;
    },

    "CY--": async function (){
        return false;
    },

    "CZ++": async function (){
        return false;
    },

    "CZ--": async function (){
        return false;
    },

    "CA++": async function (){
        return false;
    },

    "CA--": async function (){
        return false;
    },
}

export const MixerJoggingService = {

    "MX++": async function (){
        return false;
    },

    "MX--": async function (){
        return false;
    },

    "MY++": async function (){
        return false;
    },

    "MY--": async function (){
        return false;
    },

    "MA++": async function (){
        return false;
    },

    "MA--": async function (){
        return false;
    },
};